"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Iterator_1 = __importDefault(require("../../Maker/Iterator"));
const TrainingInterface_1 = require("../../../../BusinessLogicLayer/TrainingInterface");
exports.default = () => new Iterator_1.default([
    TrainingInterface_1.WeekDayType.TRAINING_DAY,
    TrainingInterface_1.WeekDayType.TRAINING_DAY,
    TrainingInterface_1.WeekDayType.RECOVERY,
    TrainingInterface_1.WeekDayType.TRAINING_DAY,
    TrainingInterface_1.WeekDayType.TRAINING_DAY,
    TrainingInterface_1.WeekDayType.TRAINING_DAY,
    TrainingInterface_1.WeekDayType.REST,
    TrainingInterface_1.WeekDayType.TRAINING_DAY,
]);
//# sourceMappingURL=getWeekDayTypeIterator.js.map